// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip-link_chip__Ipy1R","black":"chip-link_black__OpDTm","transparent":"chip-link_transparent__lHEBn"};